<template>
  <div>
    <table class="bto-sb-table" v-if="!betDetails.timeOut">
      <thead>
        <tr>
          <th>{{t('Global.DateCreated')}}</th>
          <th v-if="notTopWinnings && !hideUserName">{{t('Betslip.Client')}}</th>
          <th>{{t('Global.Currency')}}</th>
          <th v-if="notTopWinnings">{{t('Betslip.Paid')}}</th>
          <th>{{t('Mobile.Status')}}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <span>{{betDetails.createdOn}}</span>
          </td>
          <td class="bto-sb-mybets-client" v-if="notTopWinnings && !hideUserName">
            <span>{{betDetails.username}}</span>
          </td>
          <td>
            <span>{{betDetails.currencyCode}}</span>
          </td>
          <td v-if="notTopWinnings">
            <span>
              <label class="bto-sb-form-control bto-sb-form-control-checkbox">
                <input type="checkbox" :checked="betDetails.paid" disabled>
                <span class="bto-sb-form-control-indicator"></span>
              </label>
            </span>
          </td>
          <td>
            <span :class="{
              'bto-sb-mybets-won': checkGroupStatus(WON),
              'bto-sb-mybets-lost': checkGroupStatus(LOST),
              'bto-sb-mybets-rejected': checkGroupStatus(REJECTED),
              'bto-sb-mybets-cashout-up': checkGroupStatus(CASHED_OUT),
              'bto-sb-mybets-placed': checkGroupStatus(PLACED),
              'bto-sb-mybets-cancelled': checkGroupStatus(CANCELED),
              'bto-sb-mybets-paid': checkGroupStatus(PAID),
              'bto-sb-mybets-pending': checkGroupStatus(PENDING),
              'bto-sb-mybets-void': checkGroupStatus(VOID),
              }">
              {{t(betDetails.betSlipGroupStatus)}}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <table class="bto-sb-table">
      <thead>
        <tr>
          <th v-if="notTopWinnings">{{t('Mobile.Type')}}</th>
          <th>{{t('Mobile.Date')}}</th>
          <th>{{t('Public.Event')}}</th>
          <th>{{t('BetSlip.Market')}}</th>
          <th>{{t('Mobile.Odds')}}</th>
          <th v-if="!betDetails.timeOut">{{t('BetSlip.Results')}}</th>
          <th>{{t('BetSlip.B')}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(event, eventIndex) in betDetails.items" :key="eventIndex">
          <td v-if="notTopWinnings">
            <span>{{t(event.type)}}</span>
          </td>
          <td>
            <span>{{event.eventDateString}}</span>
          </td>
          <td :class="generateEventClass">
            <span>
              {{ generateEventText(event) }}
            </span>
          </td>
          <td>
            <span>{{event.market}}</span>
          </td>
          <td :class="{'bto-sb-negotiation-change':hasChanged(event.odd)}">
            <span :class="{'bto-sb-negotiation-change-bet':hasChanged(event.odd)}">{{parseFloat(event.odd)|formatOddDisplay($root.oddFormat)}}</span>
          </td>
          <td v-if="!betDetails.timeOut">
            <span :class="{
              'bto-sb-mybets-won': checkEventStatus(event,WON),
              'bto-sb-mybets-lost': checkEventStatus(event,LOST),
              'bto-sb-mybets-rejected': checkEventStatus(event,REJECTED),
              'bto-sb-mybets-cashout-up': checkEventStatus(event,CASHED_OUT),
              'bto-sb-mybets-placed': checkEventStatus(event,PLACED),
              'bto-sb-mybets-cancelled': checkEventStatus(event,CANCELED),
              'bto-sb-mybets-paid': checkEventStatus(event,PAID),
              'bto-sb-mybets-pending': checkEventStatus(event,PENDING),
              'bto-sb-mybets-void': checkEventStatus(event,VOID),
              }">
                {{t(event.itemStatusName)}}
              </span>
          </td>
          <td>
            <span>
              <label class="bto-sb-form-control bto-sb-form-control-checkbox">
                <input type="checkbox" :checked="event.banker" disabled>
                <span class="bto-sb-form-control-indicator"></span>
              </label>
            </span>
          </td>
        </tr>
        <tr v-if="showTotalOdds">
          <td><span></span></td>
          <td><span></span></td>
          <td><span></span></td>
          <td><span>{{t('W.totalsOdds')}}</span></td>
          <td><span>{{betDetails.odds|formatOddDisplay($root.oddFormat)}}</span></td>
          <td><span></span></td>
          <td><span></span></td>
        </tr>
      </tbody>
    </table>
    <table class="bto-sb-table">
      <thead>
        <tr>
          <th>{{t('Betslip.BetType')}}</th>
          <th>{{t('Betslip.NoOfBets')}}</th>
          <th>{{t('Mobile.unitstake')}}</th>
          <th>{{t('Mobile.Stake')}}</th>
          <th>{{t('Mobile.Bonus')}}</th>
          <th v-if="betDetails.tax">{{t('Mobile.Tax')}}</th>
          <th>{{t('Mobile.PossibleWinnings')}}</th>
          <th v-if="!betDetails.timeOut">{{t('Mobile.Winnings')}}</th>
          <th v-if="!betDetails.timeOut">{{t('Mobile.Status')}}</th>
          <th v-if="!betDetails.timeOut">{{t('Betslip.Note')}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(combination, combinationsIndex) in betDetails.combinations" :key="combinationsIndex">
          <td>
            <span>{{t(combination.betType)}}</span>
          </td>
          <td>
            <span>{{combination.numOfBets}}</span>
          </td>
          <td :class="{'bto-sb-negotiation-change':hasChanged(combination.unitStake)}">
            <span :class="{'bto-sb-negotiation-change-bet':hasChanged(combination.unitStake)}">
              {{combination.unitStake|formatAmountDisplay(betDetails.currencyCode)}}
            </span>
          </td>
          <td :class="{'bto-sb-negotiation-change':hasChanged(combination.stake)}">
            <span :class="{'bto-sb-negotiation-change-bet':hasChanged(combination.stake)}">
              {{combination.stake|formatAmountDisplay(betDetails.currencyCode)}}
            </span>
          </td>
          <td :class="{'bto-sb-negotiation-change':hasChanged(combination.bonus)}">
            <span :class="{'bto-sb-negotiation-change-bet':hasChanged(combination.bonus)}">
              {{combination.bonus|formatAmountDisplay(betDetails.currencyCode)}}
            </span>
          </td>
          <td v-if="combination.tax" :class="{'bto-sb-negotiation-change':hasChanged(combination.tax)}">
            <span :class="{'bto-sb-negotiation-change-bet':hasChanged(combination.tax)}">
              {{combination.tax|formatAmountDisplay(betDetails.currencyCode)}}
            </span>
          </td>
          <td :class="{'bto-sb-negotiation-change':hasChanged(combination.potWinnings)}">
            <span :class="{'bto-sb-negotiation-change-bet':hasChanged(combination.potWinnings)}">
              {{combination.potWinnings|formatAmountDisplay(betDetails.currencyCode)}}
            </span>
          </td>
          <td v-if="!betDetails.timeOut">
            <span>{{combination.winnings|formatAmountDisplay(betDetails.currencyCode)}}</span>
          </td>
          <td v-if="!betDetails.timeOut">
            <span :class="{
              'bto-sb-mybets-won': checkCombStatus(combination, WON),
              'bto-sb-mybets-lost': checkCombStatus(combination, LOST),
              'bto-sb-mybets-rejected': checkCombStatus(combination, REJECTED),
              'bto-sb-mybets-cashout-up': checkCombStatus(combination, CASHED_OUT),
              'bto-sb-mybets-placed': checkCombStatus(combination, PLACED),
              'bto-sb-mybets-cancelled': checkCombStatus(combination, CANCELED),
              'bto-sb-mybets-paid': checkCombStatus(combination,PAID),
              'bto-sb-mybets-pending': checkCombStatus(combination,PENDING),
              'bto-sb-mybets-void': checkCombStatus(combination,VOID),
              }">
              {{t(combination.combStatus)}}
            </span>
          </td>
          <td v-if="!betDetails.timeOut"><span>-</span></td>
        </tr>
        <tr v-if="betDetails.combinations">
          <td>
            <span>{{ t('Mobile.totals') }}</span>
          </td>
          <td>
            <span>{{betDetails.totalNumOfBets}}</span>
          </td>
          <td :class="{'bto-sb-negotiation-change':hasChanged(betDetails.unitStake)}">
            <span :class="{'bto-sb-negotiation-change-bet':hasChanged(betDetails.unitStake)}">
              {{betDetails.unitStake|formatAmountDisplay(betDetails.currencyCode)}}
            </span>
          </td>
          <td :class="{'bto-sb-negotiation-change':hasChanged(betDetails.stake)}">
            <span :class="{'bto-sb-negotiation-change-bet':hasChanged(betDetails.stake)}">
              {{ betDetails.stake|formatAmountDisplay(betDetails.currencyCode)}}
            </span>
          </td>
          <td :class="{'bto-sb-negotiation-change':hasChanged(betDetails.bonus)}">
            <span :class="{'bto-sb-negotiation-change-bet':hasChanged(betDetails.bonus)}">
              {{betDetails.bonus|formatAmountDisplay(betDetails.currencyCode)}}
            </span>
          </td>
          <td v-if="betDetails.tax" :class="{'bto-sb-negotiation-change':hasChanged(betDetails.tax)}">
            <span :class="{'bto-sb-negotiation-change-bet':hasChanged(betDetails.tax)}">
              {{betDetails.tax|formatAmountDisplay(betDetails.currencyCode)}}
            </span>
          </td>
          <td :class="{'bto-sb-negotiation-change':hasChanged(betDetails.potWinnings)}">
            <span :class="{'bto-sb-negotiation-change-bet':hasChanged(betDetails.potWinnings)}">
              {{betDetails.potWinnings|formatAmountDisplay(betDetails.currencyCode)}}
            </span>
          </td>
          <td v-if="!betDetails.timeOut">
            <span>{{betDetails.winnings|formatAmountDisplay(betDetails.currencyCode)}}</span>
          </td>
          <td v-if="!betDetails.timeOut">
            <span :class="{
              'bto-sb-mybets-won': checkGroupStatus(WON),
              'bto-sb-mybets-lost': checkGroupStatus(LOST),
              'bto-sb-mybets-rejected': checkGroupStatus(REJECTED),
              'bto-sb-mybets-cashout-up': checkGroupStatus(CASHED_OUT),
              'bto-sb-mybets-placed': checkGroupStatus(PLACED),
              'bto-sb-mybets-cancelled': checkGroupStatus(CANCELED),
              'bto-sb-mybets-paid': checkGroupStatus(PAID),
              'bto-sb-mybets-pending': checkGroupStatus(PENDING),
              'bto-sb-mybets-void': checkGroupStatus(VOID),
              }">
              {{t(betDetails.betSlipGroupStatus)}}
            </span>
          </td>
          <td v-if="!betDetails.timeOut"><span>-</span></td>
        </tr>
      </tbody>
    </table>
    <template v-if="betDetails.timeOut">
      <div class="bto-sb-negotiation-messages">
        <inline-message v-if="negotiationProcessed" :type="processedMessage.type" :message="processedMessage.text" />
        <template v-else>
          <inline-message :type="'warning'" :message="t('W.N.O')"/>
          <inline-message v-if="betDetails.negotiationMessage" type="info" :message="t(betDetails.negotiationMessage)"/>
        </template>
      </div>
      <div class="bto-sb-negotiation-action" v-if="!negotiationProcessed">
        <div class="bto-sb-negotiation-action-col bto-sb-negotiation-action-col-left">
          <span class="bto-sb-negotiation-action-text">
            <i class="bto-app-icon bto-app-upcoming"></i>
            <strong>{{t('Negotiate.Timeout')}}</strong>
            <span class="bto-sb-negotiation-action-time">{{genereteTimeText(this.betDetails.tick)}}</span>
          </span>
        </div>
        <div class="bto-sb-negotiation-action-col">
          <template v-if="this.betDetails.tick > 0">
            <button type="submit" class="bto-sb-form-btn bto-sb-negotiation-accept" @click="$emit('acceptNegotiation',betDetails)">{{t('Mobile.AcceptChanges')}}</button>
            <button type="submit" class="bto-sb-form-btn bto-sb-negotiation-reject" @click="$emit('rejectNegotiation',betDetails)">{{t('W.DiscardBet')}}</button>
          </template>
        </div>
      </div>
      <div class="bto-sb-negotiation-action" v-else-if="negotiationProcessed">
        <div class="bto-sb-negotiation-action-col">
          <button type="submit" class="bto-sb-form-btn bto-sb-negotiation-cancel" @click="$emit('close')">{{t('Public.Close')}}</button>
        </div>
      </div>
    </template>
    <mybet-details-footer :betDetails="betDetails" v-else-if="notTopWinnings && betDetails.isOpen" v-on="$listeners" />
  </div>
</template>
<script>
  import store from '../../../../store';
  import Base from './base';
  import { genereteTimeText } from '@bto-services/utils';
  import MybetDetailsFooter from '../mybet-details-footer/web';

  export default {
    name: 'MybetDetailsWeb',
    extends: Base,
    components: {
      MybetDetailsFooter,
    },
    data() {
      return {
        negotiationProcessed: false,
        processedMessage: {},
        unsubscribe: null,
        hideUserName: APP_SETTINGS.myBets.hideUserName,
      };
    },
    computed: {
      generateEventClass() {
        return this.betDetails.timeOut ? ['bto-sb-negotiation-events'] : ['bto-sb-mybets-events'];
      },
    },
    mounted() {
      // if we are in negotiation details
      if (this.betDetails.timeOut) {
        // listen to vuex store dispatch events
        this.unsubscribe = store.subscribeAction((action) => {
          // if event is not processOffer return
          if (action.type !== 'processOffer') {
            return;
          }
          // if processOffer event if for different betId return
          if (action.payload.betSlipGroupID !== this.betDetails.betSlipGroupID) {
            return;
          }
          // negotiation has been processed remove buttons
          this.negotiationProcessed = true;
          // we clicked on the negotiation buttons so display appropriate text based on action
          if (action.payload.clicked) {
            this.processedMessage = {
              text: action.payload.isAccepted ? this.$translate.text('Negotiate.AcceptMsg') : this.$translate.text('Negotiate.RejectMsg'),
              type: 'info',
            };
          } else {
            // negotiation offer expiared
            const timedOutMsg = this.$translate.text('Mobile.negotiationtimeout').replace('[ID]', action.payload.betSlipGroupID);
            this.processedMessage = {
              text: timedOutMsg,
              type: 'warning',
            };
          }
          this.unsubscribe();
        });
      }
    },
    beforeDestroy() {
      if (this.unsubscribe) {
        this.unsubscribe();
      }
    },
    methods: {
      genereteTimeText,
      generateEventText(event) {
        const sName = event.sportName ? `${event.sportName} -> ` : '';
        const cName = event.categoryName ? `${event.categoryName} -> ` : '';
        const tName = event.tournamentName ? `${event.tournamentName} -> ` : '';
        const mName = event.matchTitle || '';
        const score = this.checkMatchType(event, this.LIVE) && event.score ? ` -> ${event.score}` : '';
        return `${sName}${cName}${tName}${mName}${score}`;
      },
    },
  };
</script>